import { render, staticRenderFns } from "./AboutGrinRouterView.vue?vue&type=template&id=74198f4d&"
import script from "./AboutGrinRouterView.vue?vue&type=script&lang=js&"
export * from "./AboutGrinRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports